import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link", "image"],
    [{ color: [] }, { background: [] }],
    ["blockquote", "code-block"],
    ["clean"],
  ],
};

export const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "align",
  "link",
  "image",
  "color",
  "background",
  "blockquote",
  "code-block",
];

export default function ConteudoEditor({ value, onChange }) {
  const [showSource, setShowSource] = useState(false);

  return (
    <div className="conteudo-editor">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 4,
        }}
      >
        <button
          type="button"
          onClick={() => setShowSource((s) => !s)}
          style={{
            fontSize: 12,
            padding: "4px 10px",
            cursor: "pointer",
            border: "1px solid #ccc",
            background: showSource ? "#333" : "#f5f5f5",
            color: showSource ? "#fff" : "#333",
            borderRadius: 3,
          }}
        >
          {showSource ? "Modo visual" : "</> Editar HTML"}
        </button>
      </div>
      {showSource ? (
        <textarea
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          spellCheck={false}
          style={{
            width: "100%",
            minHeight: 320,
            fontFamily: "monospace",
            fontSize: 13,
            padding: 10,
            border: "1px solid #ccc",
            borderRadius: 3,
          }}
        />
      ) : (
        <ReactQuill
          theme="snow"
          value={value || ""}
          onChange={onChange}
          modules={quillModules}
          formats={quillFormats}
          style={{ minHeight: 300 }}
        />
      )}
    </div>
  );
}
